// src/features/staff/pages/ProfilePage/components/AccountInfoCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import {
  AccessTime as AccessTimeIcon,
  CalendarToday as CalendarTodayIcon,
} from '@mui/icons-material';
import LocalizedDateDistance, { parseUTCToLocalTimezone, getDateLocale } from '../../../../../i18n/LocalizedDateDistance';
import { format } from 'date-fns';

export default function AccountInfoCard({ profileData }) {
  const { t, i18n } = useTranslation(['staff', 'common']);

  const formatDate = (dateString) => {
    if (!dateString) return t('common:labels.never');
    
    // Convert UTC to local timezone
    const zonedDate = parseUTCToLocalTimezone(dateString, i18n.language);
    
    // Format with locale-specific formatting
    return format(zonedDate, 'PPPp', {
      locale: getDateLocale(i18n.language)
    });
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('staff:profile.account_information')}
        </Typography>

        <Box>
          <Box>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              <Box display="flex" alignItems="center" gap={0.5}>
                <AccessTimeIcon fontSize="small" />
                {t('staff:profile.last_login')}
              </Box>
            </Typography>
            <Typography variant="body1">
              {profileData.last_login ? (
                <>
                  <LocalizedDateDistance date={profileData.last_login} />
                  <Typography variant="caption" color="text.secondary" display="block">
                    {formatDate(profileData.last_login)}
                  </Typography>
                </>
              ) : (
                t('common:labels.never')
              )}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              <Box display="flex" alignItems="center" gap={0.5}>
                <CalendarTodayIcon fontSize="small" />
                {t('staff:profile.account_created')}
              </Box>
            </Typography>
            <Typography variant="body1">
              <LocalizedDateDistance date={profileData.created_at} />
              <Typography variant="caption" color="text.secondary" display="block">
                {formatDate(profileData.created_at)}
              </Typography>
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}